import { apiCall } from "../../../services/api-service";

export const submitAPI = (body) => apiCall("post", "vehicle", body);

export const getVehicleNoDetAPI = (body) =>
  apiCall("post", "vehicle/get_details", body);

export const getEparivahanAPI = () =>
  apiCall("get", "vehicle/api_integration_enable");

export const getVehicleNoAPI = (id, params) =>
  apiCall("get", `vehicle/history_list/${id}`, null, { params });

export const UpdateAPI = (body, id) => apiCall("put", `vehicle/${id}`, body);

export const refreshVehicleHistoryAPI = (vehicleNumber) =>
  apiCall("post", "vehicle/refresh_history", {
    vehicle_number: vehicleNumber,
  });

export const getMaintenCategApi = () =>
  apiCall("get", "get_maintenance_category");

export const getCategoryField = (id) =>
  apiCall("get", `get_fields/${id}`);

export const getVehicleEditDetAPI = (id) =>
  apiCall("get", `vehicle/edit/${id}`);

export const saveAttachmentApi = (id, body) =>
  apiCall("put", `vehicle/add_attachment/${id}`, body);